export default "__VITE_ASSET__44adbf13__"